<template>
  <el-dialog title="Forgot password" :visible.sync="isShowForgotPasswordForm"
    :closeOnClickModal="false"
    class="medium register-dialog"
    :custom-class="loading ? 'loading' : ''"
   >
    <el-form :model="form" @submit.prevent.native="forgotPassword">
      <el-form-item :label="$t('TEXT_EMAIL')" :label-width="formLabelWidth">
        <el-input v-model="form.email" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="forgotPassword" :disabled="!isValidated" class="btn btn-primary"
       >Reset my password</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      form: {
        email: ''
      },
      formLabelWidth: '120px'
    }
  },
  computed: {
    isShowForgotPasswordForm: {
      get () {
        return this.$store.getters.isShowForgotPasswordForm
      },
      set (val) {
        this.$store.dispatch('toggleForgotPasswordFormModal')
      }
    },
    isValidated () {
      return this.form.email
    }
  },
  methods: {
    toggleModal () {
      this.$store.dispatch('toggleForgotPasswordFormModal')
    },
    forgotPassword () {
      if (!this.isValidated || this.isLoading) return
      this.loading = true
      console.log('send forgot')
      this.$store.dispatch('forgotPassword', this.form).then(status => {
        this.loading = false
        if (status) {
          this.$store.dispatch('toggleForgotPasswordFormModal')
        }
      })
    }
  }
}
</script>
